import { render, staticRenderFns } from "./TenantCenterUsageSumarry.vue?vue&type=template&id=2c07df8c&scoped=true&lang=pug"
import script from "./TenantCenterUsageSumarry.vue?vue&type=script&lang=js"
export * from "./TenantCenterUsageSumarry.vue?vue&type=script&lang=js"
import style0 from "./TenantCenterUsageSumarry.vue?vue&type=style&index=0&id=2c07df8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07df8c",
  null
  
)

export default component.exports